import { useQuery } from '@tanstack/react-query';
import { LOCATIONS, LOCATIONS_INFO_V2 } from 'constants/endpoints.api';
import { Method } from 'constants/enums';
import { useEsiteCtx } from 'services/esite/context';
import { getRelativeURLWithParams } from 'utils/url';
import { DealerStore } from 'components/pcc-components';
import { getStoreHours } from 'services/location/utils';
import { useTranslations } from 'next-intl';

export const useLocationQuery = (
  store: DealerStore,
  isAvailByBranch: boolean,
  isDealerLocationFlag: boolean
) => {
  const t = useTranslations();
  const { locale } = useEsiteCtx();

  return useQuery({
    // TODO: dependencies missing in queryKey: isDealerLocationFlag
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['location', store?.id, store?.storeId, locale],
    queryFn: async () => {
      const locationInfo = isDealerLocationFlag ? LOCATIONS_INFO_V2 : LOCATIONS;
      const url = getRelativeURLWithParams(`${locationInfo}/${store?.id}`, {
        storeId: store?.storeId,
        locale
      });
      const res = await fetch(url, {
        method: Method.GET
      });
      if (res.ok) {
        const response = await res.json();
        const { storeHours } = response;
        const modifiedResponse = {
          ...response,
          storeHours: getStoreHours(storeHours, t('OPEN_24_HOUR'))
        };
        return modifiedResponse;
      } else {
        throw new Error('server error');
      }
    },
    enabled: !!isDealerLocationFlag || !!isAvailByBranch
  });
};
